const edgeUrl = (process.env.REACT_APP_SUPABASE_EDGE_URL || process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const superActionUrl = (
  process.env.REACT_APP_SUPER_ACTION_URL ||
  'https://anleaexwfuafgtwfvfin.supabase.co/functions/v1/super-action'
).replace(/\/$/, '');

const defaultHeaders = {
  'Content-Type': 'application/json',
};

const apiFetch = async (path, options = {}) => {
  const url = `${edgeUrl}${path}`;
  const response = await fetch(url, {
    headers: {
      ...defaultHeaders,
      ...(options.headers || {}),
    },
    ...options,
  });

  const text = await response.text();
  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch (error) {
    throw new Error('Invalid JSON response from Supabase edge function');
  }

  if (!response.ok) {
    const error = new Error(data?.message || data?.error || `Request failed with status ${response.status}`);
    error.status = response.status;
    error.body = data;
    throw error;
  }

  return data;
};

const trackEvent = (path, payload = {}) => {
  if (!superActionUrl) return;

  fetch(`${superActionUrl}${path}`, {
    method: 'POST',
    headers: {
      ...defaultHeaders,
    },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch((error) => {
    console.warn(`Unable to track ${path}`, error);
  });
};

export const trackContact = (channel) => {
  trackEvent(`/contact/${channel}`);
};

export const trackTotalVisit = () => {
  trackEvent('/totalvisit');
};

export const registerUser = async (payload) => {
  return apiFetch('/register', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const loginUser = async (payload) => {
  return apiFetch('/login', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const saveUserAddress = async ({ userId, token, address, locationLink, lat, lng }) => {
  return apiFetch('/address', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, address, locationLink, lat, lng }),
  });
};

export const getUserAddress = async (token) => {
  return apiFetch('/addresses', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createBooking = async ({ userId, token, booking }) => {
  return apiFetch('/store-booking', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, ...booking }),
  });
};

export const updateUserProfile = async ({ userId, token, profile }) => {
  return apiFetch('/profile', {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, ...profile }),
  });
};

export const changeUserPassword = async ({ userId, token, currentPassword, newPassword }) => {
  return apiFetch('/change-password', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, currentPassword, newPassword }),
  });
};

export const fetchUserBookings = async (userId, token) => {
  return apiFetch(`/mybooking/${encodeURIComponent(userId)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateBookingStatus = async (bookingId, status) => {
  return apiFetch(`/bookings/${bookingId}/status`, {
    method: 'PUT',
    body: JSON.stringify({ status }),
  });
};

export const getBookingStatus = async (bookingId) => {
  return apiFetch(`/bookings/${bookingId}/status`, {
    method: 'GET',
  });
};
